/*                                                          */
import { DEV } from 'esm-env';
import { is_promise } from '../../../shared/utils.js';
import { block, branch, pause_effect, resume_effect } from '../../reactivity/effects.js';
import { internal_set, mutable_source, source } from '../../reactivity/sources.js';
import { set_active_effect, set_active_reaction } from '../../runtime.js';
import {
	hydrate_next,
	hydrate_node,
	hydrating,
	remove_nodes,
	set_hydrate_node,
	set_hydrating
} from '../hydration.js';
import { queue_micro_task } from '../task.js';
import { HYDRATION_START_ELSE, UNINITIALIZED } from '../../../../constants.js';
import {
	component_context,
	dev_stack,
	is_runes,
	set_component_context,
	set_dev_current_component_function,
	set_dev_stack
} from '../../context.js';
import { flushSync } from '../../reactivity/batch.js';

const PENDING = 0;
const THEN = 1;
const CATCH = 2;

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function await_block(node, get_input, pending_fn, then_fn, catch_fn) {
	if (hydrating) {
		hydrate_next();
	}

	var anchor = node;
	var runes = is_runes();
	var active_component_context = component_context;

	/*              */
	var component_function = DEV ? component_context?.function : null;
	var dev_original_stack = DEV ? dev_stack : null;

	/*                                                */
	var input = UNINITIALIZED;

	/*                        */
	var pending_effect;

	/*                        */
	var then_effect;

	/*                        */
	var catch_effect;

	var input_source = runes
		? source(/*            */ (undefined))
		: mutable_source(/*            */ (undefined), false, false);
	var error_source = runes ? source(undefined) : mutable_source(undefined, false, false);
	var resolved = false;

	/**
 *
 *
 */
	function update(state, restore) {
		resolved = true;

		if (restore) {
			set_active_effect(effect);
			set_active_reaction(effect); /*                    */
			set_component_context(active_component_context);
			if (DEV) {
				set_dev_current_component_function(component_function);
				set_dev_stack(dev_original_stack);
			}
		}

		try {
			if (state === PENDING && pending_fn) {
				if (pending_effect) resume_effect(pending_effect);
				else pending_effect = branch(() => pending_fn(anchor));
			}

			if (state === THEN && then_fn) {
				if (then_effect) resume_effect(then_effect);
				else then_effect = branch(() => then_fn(anchor, input_source));
			}

			if (state === CATCH && catch_fn) {
				if (catch_effect) resume_effect(catch_effect);
				else catch_effect = branch(() => catch_fn(anchor, error_source));
			}

			if (state !== PENDING && pending_effect) {
				pause_effect(pending_effect, () => (pending_effect = null));
			}

			if (state !== THEN && then_effect) {
				pause_effect(then_effect, () => (then_effect = null));
			}

			if (state !== CATCH && catch_effect) {
				pause_effect(catch_effect, () => (catch_effect = null));
			}
		} finally {
			if (restore) {
				if (DEV) {
					set_dev_current_component_function(null);
					set_dev_stack(null);
				}

				set_component_context(null);
				set_active_reaction(null);
				set_active_effect(null);

				/*                                                                      */
				/*                                                                     */
				flushSync();
			}
		}
	}

	var effect = block(() => {
		if (input === (input = get_input())) return;

		/*                                                                                                     */
		/*                                                                                  */
		let mismatch = hydrating && is_promise(input) === (anchor.data === HYDRATION_START_ELSE);

		if (mismatch) {
			/*                                                                      */
			anchor = remove_nodes();

			set_hydrate_node(anchor);
			set_hydrating(false);
			mismatch = true;
		}

		if (is_promise(input)) {
			var promise = input;

			resolved = false;

			promise.then(
				(value) => {
					if (promise !== input) return;
					/*                                                                   */
					/*                                                             */
					internal_set(input_source, value);
					update(THEN, true);
				},
				(error) => {
					if (promise !== input) return;
					/*                                                                   */
					/*                                                             */
					internal_set(error_source, error);
					update(CATCH, true);
					if (!catch_fn) {
						/*                                         */
						throw error_source.v;
					}
				}
			);

			if (hydrating) {
				if (pending_fn) {
					pending_effect = branch(() => pending_fn(anchor));
				}
			} else {
				/*                                                                      */
				/*                                                     */
				queue_micro_task(() => {
					if (!resolved) update(PENDING, true);
				});
			}
		} else {
			internal_set(input_source, input);
			update(THEN, false);
		}

		if (mismatch) {
			/*                         */
			set_hydrating(true);
		}

		/*                                                                         */
		return () => (input = UNINITIALIZED);
	});

	if (hydrating) {
		anchor = hydrate_node;
	}
}
